import { useContext } from 'react';

import { LeavePageContext } from '@app/providers';
import { logOutUser } from '@app/utils';

export const useLogoutModal = () => {
  const { prepareStartedData } = useContext(LeavePageContext);

  const handleCancel = (setIsModalOpen: (value: boolean) => void) => {
    setIsModalOpen(false);
  };

  const handleOk = async (setIsModalOpen: (value: boolean) => void) => {
    setIsModalOpen(false);
    prepareStartedData({});
    await logOutUser();
  };

  return {
    handleOk,
    handleCancel,
  };
};
